import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import { Link } from "react-router-dom";
import { TagMatchResultDto } from "../common/dto/TagMatchResultDto";

type State = {
    result: TagMatchResultDto | null,
    selectedTag: string
}

export default class TagMatchListPage extends Component<ServiceCollectionParam, State> {

    state: State = {
        result: null,
        selectedTag: 'all',
    }

    async componentDidMount() {
        await this.refresh();
    }

    async refresh() {
        const result = await this.props.services.dao
            .findTagMatches(this.state.selectedTag);

        this.state.result = result;

        this.setState(this.state);
    }

    async handleChange(event) {
        this.state.selectedTag = event.target.value;

        this.setState(this.state);

        await this.refresh();
    }

    async deleteByTag() {
        await this.props.services.dao
            .deleteCodeMatchByTag(this.state.selectedTag);

        this.setState({ selectedTag: 'all' });

        await this.refresh();
    }

    render() {
        if (this.state.result === null) {
            return '';
        }

        return (
            <>
            <div className="d-flex justify-content-between">
                <select value={this.state.selectedTag}
                        className="form-select"
                        onChange={ this.handleChange.bind(this) }>
                    <option value="all">Kõik</option>
                    {
                        this.state.result.counts.map(each =>
                            <option key={each.tag} value={each.tag}>{each.tag}</option>
                        )
                    }
                    <option value="problems">Probleemid</option>
                </select>

                <button onClick={ () => this.deleteByTag() }
                        className="mx-3 px-4 btn btn-danger">Kustuta!</button>

            </div>

            <table className="table table-sm caption-top user-dashboard">
                <thead>
                <tr>
                    <th scope="col">Tag</th>
                    <th scope="col">Autorid</th>
                    <th scope="col">Kattuvaid plokke</th>
                    <th scope="col">Kattuvaid ridu</th>
                </tr>
                </thead>
                <tbody>
                { this.state.result.lines.map(row =>
                    <tr key={row._id}
                        className={ row.isProblem ? 'table-danger' : '' }>
                        <td>{ row.tag }</td>
                        <td><Link to={'/tag-matches/' + row._id}>{ row.user1 } / { row.user2 }</Link></td>
                        <td>0</td>
                        <td>{ row.matchedLineCount }</td>
                    </tr>
                )}
                </tbody>
            </table>
            </>);
    }

}

